const resolveCollectionTree = require("./helpers/resolveCollectionTree")
const fetchStatamicResource = require("./helpers/fetchStatamicResource")

module.exports = {
  resolveCollectionTree,
  fetchStatamicResource,
}
// noop
